@if (header && content && !routeChanging) {
    @if (!isPartialCollapsible) {
        <div class="content-box" [class.collapsed]="collapsed">
            <div class="content-box-header" [class.open]="!collapsed" (click)="toggle()">
                @if (primaryHeader) {
                    <h1 class="title">{{ header }}</h1>
                } @else {
                    <h2 class="title">{{ header }}</h2>
                }
                <div class="toggle-arrow">
                    @if (collapsed) {
                        <vn-icon name="theme-down" size="14" />
                    } @else {
                        <vn-icon name="theme-up" size="14" />
                    }
                </div>
            </div>
            <div class="content" [innerHtml]="content" [class.hidden]="collapsed"></div>
        </div>
    } @else {
        <div class="collapsible-container card-bg content-box" [class.collapsible-container--collapsed]="!collapsed">
            <div class="header-light collapsible-container__header dh" (click)="toggle()">
                <div class="h5-v2 collapsible-container__title">{{ header }}</div>
                <div class="h5-v2 collapsible-container__arrow">
                    <vn-icon name="theme-arrow-down" size="16" />
                </div>
            </div>
            <div class="collapsible-container__content content" [innerHtml]="content"></div>
            <div class="collapsible-container__footer dh text-center" (click)="toggle()">
                <span class="animated-underline">{{ collapsed ? sitecore.seo.ShowLess : sitecore.seo.ShowMore }}</span>
            </div>
        </div>
    }
}
